module.exports = __webpack_public_path__ + "38ea46b0f7c7c81758d1d5108b1cfc0e.MP3";